(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filterButtons = document.querySelectorAll('.c3-filter-button');
  const collectionContents = document.querySelectorAll('.c3-collection-content');
  const categoriesGrid = document.querySelector('.c3-categories-grid');
  const collectionDisplay = document.querySelector('.c3-collection-display');

  // Function to set the active button
  const setActiveButton = (activeButton) => {
    filterButtons.forEach(btn => btn.classList.remove('active'));
    activeButton.classList.add('active');
  };

  // Function to show categories grid and hide collection display
  const showCategoriesGrid = () => {
    categoriesGrid.classList.remove('hidden');
    collectionDisplay.classList.add('hidden');
    collectionContents.forEach(content => {
      content.classList.remove('active');
    });
     // Scroll to the top of the categories grid
     categoriesGrid.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  // Function to show collection display and hide categories grid
  const showCollectionDisplay = (collectionId) => {
     categoriesGrid.classList.add('hidden');
     collectionDisplay.classList.remove('hidden');

     // Hide all collection contents
     collectionContents.forEach(content => {
       content.classList.remove('active');
     });

     // Show the selected collection content
     const selectedCollection = document.getElementById(`collection-${collectionId}`);
     if (selectedCollection) {
       selectedCollection.classList.add('active');

       // Scroll to the collection display
       selectedCollection.scrollIntoView({
         behavior: 'smooth',
         block: 'start'
       });
     }
  };

  // Initial state: show categories grid, hide collection display, activate 'All' button
  showCategoriesGrid();
  setActiveButton(document.querySelector('.c3-filter-button[data-filter="all"]'));

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      const filterId = button.dataset.filter;

      setActiveButton(button);

      if (filterId === 'all') {
        showCategoriesGrid();
      } else {
        showCollectionDisplay(filterId);
      }
    });
  });

  // Add click listener for Shop Now buttons on category cards
  categoriesGrid.addEventListener('click', (event) => {
    const shopNowButton = event.target.closest('.c3-shop-now-button');
    if (shopNowButton) {
      const categoryCard = shopNowButton.closest('.c3-category-card');
      const collectionUrl = categoryCard.dataset.collectionUrl;
      if (collectionUrl) {
        window.location.href = collectionUrl; // Navigate to collection page
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
